<template>
  <base-content
    :data="data"
    :index="index"
    view="list"
  >
    <template #card-header>
      <partial-title :title="name" :link="link" />
    </template>

    <template #card-body>
      <partial-description v-if="description"
        :description="description"
        :isLoading="highlightsLoading">
      </partial-description>

      <ul v-if="!isEmpty(matches)" :class="{ 'mt-2': description }">
        <matches :matches="matches" view="list" />
      </ul>
    </template>

    <template v-if="!isEmpty(owners) || !isEmpty(data.organisations)" #card-footer>
      <partial-owners v-if="!isEmpty(owners)"
        :owners="owners"
        :totalOwners="data.researchers_count"
        :maxItems="maxOwners"
        :highlights="highlightResearchers"
        :highlightKeys="['researchers.full_name.normalized', 'researchers.initial_name.normalized']">
      </partial-owners>

      <partial-organisations v-if="!isEmpty(data.organisations)"
        :organisations="data.organisations"
        :highlights="highlightOrganisations"
        :highlightKey="'organisations.name'"
        :lineClamp="1">
      </partial-organisations>
    </template>

    <template #card-actions>
      <slot name="actions"></slot>
    </template>
  </base-content>
</template>

<script>
import processing from '@/mixins/search/results/researchGroup'

import BaseContent from '@/components/search/results/BaseContent'
import Matches from '@/components/search/results/partials/Matches'
import PartialDescription from '@/components/search/results/partials/Description'
import PartialTitle from '@/components/search/results/partials/Title'
import PartialOwners from '@/components/search/results/partials/Owners'
import PartialOrganisations from '@/components/search/results/partials/Organisations'

export default {
  name: 'researchGroupResultList',
  mixins: [processing],
  components: {
    Matches,
    PartialTitle,
    PartialDescription,
    PartialOwners,
    PartialOrganisations,
    BaseContent
  },
  data () {
    return {
      maxOwners: 4
    }
  },
  computed: {
    owners () {
      return !this.isEmpty(this.data.owners) ? this.data.owners.slice(0, this.maxOwners) : []
    }
  }
}
</script>
